import lazyImport from '../../Utils/Loading/loadingHelpers'

export const CardSwiper = lazyImport(() => import('./CardSwiperMain'))
